export default __webpack_public_path__ + "static/media/stressmanagement.57228b84.jpg";